<!doctype html>
<html lang="ar" dir=RTL>

<head>
   <meta http-equiv="Content-Type" content="text/html;charset=UTF-8">
   <meta name=ProgId content=Excel.Sheet>
   <meta name=Generator content="Microsoft Excel 15">
   <link rel=File-List href="Attachment%207.1_Template%20of%20MOHE_Prep-101_files/filelist.xml">

   <style id="Attachment 7.1_Template of MOHE_Prep-101_20905_Styles">
      {
         mso-displayed-decimal-separator: "\.";
         mso-displayed-thousand-separator: "\,";
      }

      .font520905 {
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
      }

      .font620905 {
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
      }

      .xl1520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 11.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl6420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 12.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl6520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl6620905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: 1.0pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: 1.0pt solid windowtext;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl6720905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border: .5pt solid windowtext;
         background: white;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl6820905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: 1.0pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl6920905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: 1.0pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl7020905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: 1.0pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl7120905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: 1.0pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl7220905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: 1.0pt solid windowtext;
         border-left: 1.0pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl7320905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: none;
         border-left: none;
         border-bottom: none;
         border-right: 1.0pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl7420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl7520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: 1.0pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl7620905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: none;
         border-left: none;
         border-bottom: none;
         border-right: 1.0pt solid windowtext;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl7720905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: right;
         vertical-align: middle;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl7820905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl7920905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: "\@";
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8020905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: "\[$-F800\]dddd\\\,\\ mmmm\\ dd\\\,\\ yyyy";
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8120905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: none;
         border-bottom: none;
         border-right: 1.0pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8220905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: none;
         border-bottom: none;
         border-right: 1.0pt solid windowtext;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl8320905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl8420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: none;
         border-bottom: 1.0pt solid windowtext;
         border-right: 1.0pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: none;
         border-bottom: 1.0pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8620905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         border-top: none;
         border-left: none;
         border-bottom: 1.0pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8720905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: 1.0pt solid windowtext;
         border-bottom: 1.0pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8820905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl8920905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9020905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: bottom;
         border: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9120905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: none;
         border-left: .5pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9220905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9320905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         border-top: none;
         border-left: .5pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         background: white;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl9520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9620905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: bottom;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9720905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: 0;
         text-align: center;
         vertical-align: middle;
         border: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9820905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: 0;
         text-align: center;
         vertical-align: bottom;
         border: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl9920905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: none;
         border-bottom: .5pt solid windowtext;
         border-right: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10020905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: none;
         border-bottom: .5pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10120905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: .5pt solid windowtext;
         border-bottom: .5pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10220905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: "0\.0";
         text-align: center;
         vertical-align: middle;
         border: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10320905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: Fixed;
         text-align: general;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: middle;
         border-top: none;
         border-left: none;
         border-bottom: 1.5pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: Fixed;
         text-align: general;
         vertical-align: middle;
         border-top: none;
         border-left: none;
         border-bottom: 1.5pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10620905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: general;
         vertical-align: bottom;
         border-top: 1.5pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10720905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: left;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10820905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: right;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl10920905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11020905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: Fixed;
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11120905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: underline;
         text-underline-style: single;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: none;
         border-left: 1.0pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11220905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: underline;
         text-underline-style: single;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: none;
         border-left: 1.0pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11320905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: bottom;
         border-top: none;
         border-left: .5pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: none;
         border-bottom: .5pt solid windowtext;
         border-right: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11520905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: .5pt solid windowtext;
         border-bottom: .5pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11620905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: right;
         vertical-align: bottom;
         border-top: .5pt solid windowtext;
         border-left: none;
         border-bottom: .5pt solid windowtext;
         border-right: .5pt solid windowtext;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl11720905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: right;
         vertical-align: bottom;
         border-top: .5pt solid windowtext;
         border-left: .5pt solid windowtext;
         border-bottom: .5pt solid windowtext;
         border-right: none;
         background: #D9D9D9;
         mso-pattern: black none;
         white-space: normal;
      }

      .xl11820905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: none;
         border-bottom: .5pt solid windowtext;
         border-right: .5pt solid windowtext;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl11920905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: .5pt solid windowtext;
         border-bottom: .5pt solid windowtext;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl12020905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl12120905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: .5pt solid windowtext;
         border-left: .5pt solid windowtext;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl12220905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 12.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: right;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl12320905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 700;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: General;
         text-align: center;
         vertical-align: middle;
         border-top: 1.0pt solid windowtext;
         border-left: none;
         border-bottom: none;
         border-right: none;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }

      .xl12420905 {
         padding: 0px;
         mso-ignore: padding;
         color: black;
         font-size: 13.0pt;
         font-weight: 400;
         font-style: normal;
         text-decoration: none;
         font-family: Calibri, sans-serif;
         mso-font-charset: 0;
         mso-number-format: Fixed;
         text-align: center;
         vertical-align: middle;
         mso-background-source: auto;
         mso-pattern: auto;
         white-space: normal;
      }
   </style>
</head>

<body>
   <div id="Attachment 7.1_Template of MOHE_Prep-101_20905" align=center x:publishsource="Excel">

      <table border=0 cellpadding=0 cellspacing=0 dir=RTL width=903 style='border-collapse:
 collapse;table-layout:fixed;width:680pt'>
         <col width=3 style='mso-width-source:userset;mso-width-alt:113;width:2pt'>
         <col width=0 style='display:none;mso-width-source:userset;mso-width-alt:1820'>
         <col width=64 style='width:48pt'>
         <col width=67 style='mso-width-source:userset;mso-width-alt:2389;width:50pt'>
         <col width=74 style='mso-width-source:userset;mso-width-alt:2645;width:56pt'>
         <col width=69 style='mso-width-source:userset;mso-width-alt:2446;width:52pt'>
         <col width=114 style='mso-width-source:userset;mso-width-alt:4067;width:86pt'>
         <col width=65 style='mso-width-source:userset;mso-width-alt:2304;width:49pt'>
         <col width=54 style='mso-width-source:userset;mso-width-alt:1934;width:41pt'>
         <col width=76 style='mso-width-source:userset;mso-width-alt:2702;width:57pt'>
         <col width=130 style='mso-width-source:userset;mso-width-alt:4636;width:98pt'>
         <col width=78 style='mso-width-source:userset;mso-width-alt:2787;width:59pt'>
         <col width=109 style='mso-width-source:userset;mso-width-alt:3868;width:82pt'>
         <tr height=19 style='height:14.4pt'>
            <td height=19 class=xl1520905 dir=LTR width=3 style='height:14.4pt;
  width:2pt'><a name="RANGE!A1:M146"></a></td>
            <td class=xl1520905 dir=LTR width=0></td>
            <td class=xl1520905 dir=LTR width=64 style='width:48pt'></td>
            <td class=xl1520905 dir=LTR width=67 style='width:50pt'></td>
            <td class=xl1520905 dir=LTR width=74 style='width:56pt'></td>
            <td class=xl1520905 dir=LTR width=69 style='width:52pt'></td>
            <td class=xl1520905 dir=LTR width=114 style='width:86pt'></td>
            <td class=xl1520905 dir=LTR width=65 style='width:49pt'></td>
            <td class=xl1520905 dir=LTR width=54 style='width:41pt'></td>
            <td class=xl1520905 dir=LTR width=76 style='width:57pt'></td>
            <td class=xl1520905 dir=LTR width=130 style='width:98pt'></td>
            <td class=xl1520905 dir=LTR width=78 style='width:59pt'></td>
            <td class=xl1520905 dir=LTR width=109 style='width:82pt'></td>
         </tr>
         <tr height=19 style='height:14.4pt'>
            <td height=19 class=xl1520905 dir=LTR style='height:14.4pt'></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td align=right valign=top>
               <span style='mso-ignore:vglayout;
  position:absolute;z-index:1;margin-right:67px;margin-top:3px;width:92px;
  height:56px'><img width=92 height=56
                     src="data:image/png;base64,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"
                     alt="GTNI  logo.jpg" v:shapes="Picture_x0020_20"></span>
               <span style='mso-ignore:vglayout2'>
                  <table cellpadding=0 cellspacing=0>
                     <tr>
                        <td height=19 class=xl1520905 dir=LTR width=78 style='height:14.4pt;
    width:59pt'></td>
                     </tr>
                  </table>
               </span>
            </td>
            <td class=xl1520905 dir=LTR></td>
         </tr>
         <tr height=21 style='height:15.6pt'>
            <td height=21 class=xl1520905 dir=LTR style='height:15.6pt'></td>
            <td class=xl1520905 dir=LTR></td>
            <td colspan=4 class=xl12220905 dir=RTL>وزارة التعليم العالي <span style='mso-spacerun:yes'></span></td>
            <td class=xl6420905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
         </tr>
         <tr height=21 style='height:15.6pt'>
            <td height=21 class=xl1520905 dir=LTR style='height:15.6pt'></td>
            <td class=xl1520905 dir=LTR></td>
            <td colspan=4 class=xl12220905 dir=RTL>المعهد الفني للتمريض بالجونة</td>
            <td class=xl6420905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
         </tr>
         <tr height=19 style='height:14.4pt'>
            <td height=19 class=xl1520905 dir=LTR style='height:14.4pt'></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
         </tr>
         <tr height=29 style='mso-height-source:userset;height:21.75pt'>
            <td height=29 class=xl1520905 dir=LTR style='height:21.75pt'></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=23 style='height:17.4pt'>
            <td height=23 class=xl6520905 dir=LTR style='height:17.4pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=5 class=xl9620905 dir=RTL>نتيجة الطلاب للعام الدراسي 2021-2022</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=24 style='height:18.0pt'>
            <td height=24 class=xl6520905 dir=LTR style='height:18.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6620905 dir=RTL> كود الطالب</td>
            <td class=xl6720905 dir=LTR>441</td>
            <td class=xl6820905 dir=LTR>&nbsp;</td>
            <td class=xl6920905 dir=RTL align=right>إسم الطالب</td>
            <td colspan=3 class=xl12320905 dir=LTR>&nbsp;</td>
            <td class=xl7020905 dir=RTL>التخصص</td>
            <td class=xl7120905 dir=RTL>عام</td>
            <td class=xl7120905 dir=LTR>&nbsp;</td>
            <td class=xl7220905 dir=LTR>&nbsp;</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7320905 dir=LTR>&nbsp;</td>
            <td class=xl7420905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7520905 dir=LTR>&nbsp;</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7620905 dir=RTL>المؤهل</td>
            <td class=xl7420905 dir=RTL>ثانوي عام</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7720905 colspan=2 dir=RTL> سنة الحصول علي المؤهل</td>
            <td class=xl7420905 dir=RTL>2021</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7820905 dir=RTL align=right>تاريخ الميلاد</td>
            <td class=xl7920905 dir=LTR></td>
            <td class=xl8020905 dir=RTL></td>
            <td class=xl7520905 dir=LTR>&nbsp;</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl8120905 dir=LTR>&nbsp;</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7520905 dir=LTR>&nbsp;</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl8220905 dir=RTL align=right>موقف القبول<span style='display:none'>مستجد</span></td>
            <td class=xl7420905 dir=RTL>مستجد</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7820905 colspan=2 dir=RTL align=right>تاريخ الإلتحاق</td>
            <td class=xl7420905 dir=RTL>2021</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7820905 colspan=2 dir=RTL align=right> رقم وتاريخ
               الإعتماد</td>
            <td class=xl7820905 dir=LTR>&nbsp;</td>
            <td rowspan=2 class=xl11120905 dir=RTL width=109 style='width:82pt'>________</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl8120905 dir=LTR>&nbsp;</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl8220905 colspan=2 dir=RTL align=right>المعدل التراكمي نقاط</td>
            <td rowspan=2 class=xl12420905 dir=RTL>2.52</td>
            <td class=xl8320905 colspan=2 dir=RTL align=right>المعدل التراكمي تقدير</td>
            <td colspan=2 rowspan=2 class=xl10920905 dir=LTR></td>
            <td class=xl7820905 colspan=2 dir=RTL align=right>عدد الساعات المكتملة</td>
            <td class=xl7820905 dir=LTR>&nbsp;</td>
            <td class=xl7520905 dir=RTL align=right>20 ساعة معتمدة</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl8420905 dir=LTR>&nbsp;</td>
            <td class=xl8520905 dir=LTR>&nbsp;</td>
            <td class=xl8620905 dir=LTR>&nbsp;</td>
            <td class=xl8620905 dir=LTR>&nbsp;</td>
            <td class=xl8520905 dir=LTR>&nbsp;</td>
            <td class=xl8520905 dir=LTR>&nbsp;</td>
            <td class=xl8520905 dir=LTR>&nbsp;</td>
            <td class=xl8720905 dir=RTL>&nbsp;</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=2 class=xl11620905 dir=RTL style='border-left:.5pt solid black'>الفصل الدراسي التمهيدي</td>
            <td class=xl8820905 dir=RTL>كود المادة</td>
            <td colspan=2 class=xl11820905 dir=RTL style='border-left:.5pt solid black'>إسـم المادة</td>
            <td class=xl8820905 dir=RTL>الدرجة</td>
            <td class=xl8820905 dir=RTL>التقدير</td>
            <td class=xl8820905 dir=RTL>النقاط</td>
            <td class=xl8820905 dir=RTL>الساعات المكتسبة</td>
            <td class=xl8820905 dir=RTL>مجموع النقاط</td>
            <td class=xl8820905 dir=RTL>موقف الطالب</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=2 class=xl9620905 dir=LTR style='border-left:.5pt solid black'></td>
            <td class=xl8920905 dir=LTR style='border-top:none'>CS110</td>
            <td colspan=2 class=xl11420905 dir=RTL style='border-left:.5pt solid black'>مقدمة في الحاسب الآلي</td>
            <td class=xl8920905 dir=LTR style='border-top:none'>74</td>
            <td class=xl8920905 dir=LTR style='border-top:none'>ناجح</td>
            <td class=xl9020905 dir=RTL style='border-top:none'>0</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>0</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>0</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>حضور</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl9620905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl9520905 dir=LTR></td>
            <td colspan=2 class=xl10920905 dir=RTL>ناجح فى المستوى التمهيدى</td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=2 class=xl11620905 dir=RTL style='border-left:.5pt solid black'>
               الفصل الدراسي الأول</td>
            <td class=xl8820905 dir=RTL>كود المادة</td>
            <td colspan=2 class=xl11820905 dir=RTL style='border-left:.5pt solid black'>إسـم المادة</td>
            <td class=xl8820905 dir=RTL>الدرجة</td>
            <td class=xl8820905 dir=RTL>التقدير</td>
            <td class=xl8820905 dir=RTL>النقاط</td>
            <td class=xl8820905 dir=RTL>الساعات المكتسبة</td>
            <td class=xl8820905 dir=RTL>مجموع النقاط</td>
            <td class=xl8820905 dir=RTL>موقف الطالب</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=2 class=xl12020905 dir=LTR width=131 style='border-left:.5pt solid black;
  width:98pt'>&nbsp;</td>
            <td class=xl8920905 dir=LTR style='border-top:none'>BI 105</td>
            <td colspan=2 class=xl11420905 dir=RTL style='border-left:.5pt solid black'>علم التشريح ووظائف الأعضاء 1</td>
            <td class=xl9720905 dir=LTR style='border-top:none'>71</td>
            <td class=xl8920905 dir=LTR style='border-top:none'>C+</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>2.8</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>4</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>11.2</td>
            <td class=xl8920905 dir=RTL style='border-top:none'>حضور</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl9920905 dir=RTL align=right style='border-top:none'>
               المجموع</td>
            <td class=xl10020905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10020905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10020905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl8920905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10120905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl8820905 dir=RTL style='border-top:none'>20</td>
            <td class=xl10220905 dir=RTL style='border-top:none'>50.4</td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7420905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=3 rowspan=2 class=xl10920905 dir=RTL>المعدل الفصلي  الثاني =</td>
            <td rowspan=2 class=xl11020905 dir=RTL>2.52</td>
            <td rowspan=2 class=xl11020905 dir=RTL>جيد</td>
            <td class=xl10320905 dir=RTL></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl10320905 dir=RTL></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl10420905 dir=LTR>&nbsp;</td>
            <td class=xl10420905 dir=LTR>&nbsp;</td>
            <td class=xl10420905 dir=LTR>&nbsp;</td>
            <td class=xl10520905 dir=RTL>&nbsp;</td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl9520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
            <td class=xl10620905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10620905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10620905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10620905 dir=LTR style='border-top:none'>&nbsp;</td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
            <td class=xl10620905 dir=LTR>&nbsp;</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 colspan=2 dir=RTL align=right>لجنة النظام و المراقبة</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=3 class=xl7420905 dir=RTL>رئيس الكنترول </td>
            <td class=xl9220905 dir=LTR></td>
            <td class=xl9220905 dir=LTR></td>
            <td colspan=2 class=xl7420905 dir=RTL>عميد المعهد </td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl9220905 dir=LTR></td>
            <td colspan=2 class=xl7420905 dir=LTR>(&#1585;&#1574;&#1610;&#1587;
               &#1593;&#1575;&#1605;
               &#1575;&#1604;&#1573;&#1605;&#1578;&#1581;&#1575;&#1606;&#1575;&#1578;)</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 colspan=3 dir=RTL align=right>كتبة :...............................</td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=3 class=xl7420905 dir=LTR>..............................</td>
            <td colspan=4 class=xl10720905 dir=LTR>………...................................</td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl7420905 dir=LTR></td>
            <td class=xl7420905 dir=LTR></td>
            <td class=xl7420905 dir=LTR></td>
            <td class=xl10720905 dir=LTR></td>
            <td class=xl10720905 dir=LTR></td>
            <td class=xl10720905 dir=LTR></td>
            <td class=xl10720905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 colspan=3 dir=RTL align=right>راجعة : ............................</td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td colspan=4 class=xl7420905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl9220905 dir=LTR></td>
            <td colspan=3 class=xl7420905 dir=RTL>التاريخ : </td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl10820905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl10820905 dir=LTR style='height:24.0pt'></td>
            <td class=xl10820905 dir=LTR></td>
            <td class=xl10820905 colspan=9 dir=RTL>
               <font class="font620905">	الرموز:</font>
               <font class="font520905">+A
                  ممتاز مرتفع ,A
                  ممتاز ,+B جيد جدا مرتفع ,Bجيدجدا
                  , +C جيد مرتفع,C  جيد  , D
                  مقبول, F ضعيف</font>
            </td>
            <td class=xl10820905 dir=LTR></td>
            <td class=xl10820905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='mso-height-source:userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl6520905 dir=LTR></td>
         </tr>
         <tr class=xl6520905 height=32 style='page-break-before:always;mso-height-source:
  userset;height:24.0pt'>
            <td height=32 class=xl6520905 dir=LTR style='height:24.0pt'></td>
            <td class=xl6520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
            <td class=xl1520905 dir=LTR></td>
         </tr>
         <!-- <![if supportMisalignedColumns]>
         <tr height=0 style='display:none'>
            <td width=3 style='width:2pt'></td>
            <td width=0></td>
            <td width=64 style='width:48pt'></td>
            <td width=67 style='width:50pt'></td>
            <td width=74 style='width:56pt'></td>
            <td width=69 style='width:52pt'></td>
            <td width=114 style='width:86pt'></td>
            <td width=65 style='width:49pt'></td>
            <td width=54 style='width:41pt'></td>
            <td width=76 style='width:57pt'></td>
            <td width=130 style='width:98pt'></td>
            <td width=78 style='width:59pt'></td>
            <td width=109 style='width:82pt'></td>
         </tr>
         <![endif]> -->
      </table>

   </div>


   <!----------------------------->
   <!--END OF OUTPUT FROM EXCEL PUBLISH AS WEB PAGE WIZARD-->
   <!----------------------------->
</body>

</html>